export default __webpack_public_path__ + "static/negative-feedback-ab4c85cc70574781cec1c7b65f7f95be.mp3";